import { useLocation } from "react-router-dom";
import { resolvePageContext, type PageEntity } from "./pageContext";
import { pageEntityName, usePageEntityName, useWizardStep, wizardStep } from "./pageEntityNames";

export const useCurrentPageEntity = (): (PageEntity & { name: string | undefined }) | null => {
  const { pathname, search } = useLocation();
  const entity = resolvePageContext(pathname, search, { entityLabel: pageEntityName, wizardStep })?.entity;
  const name = usePageEntityName(entity?.id);
  useWizardStep(entity?.step ? entity.id : undefined);
  return entity ? { ...entity, name } : null;
};
